var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "multiplePeopleCase" } },
    [
      !_vm.isLoadingShow
        ? [
            _c("c-header-return", {
              attrs: { isCustom: true, isBtnShow: true },
              scopedSlots: _vm._u(
                [
                  {
                    key: "customTitle",
                    fn: function () {
                      return [
                        _vm.mpc_info.cases && _vm.mpc_info.cases.length > 1
                          ? _c(
                              "el-tooltip",
                              { attrs: { placement: "bottom" } },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _vm._l(
                                      _vm.mpc_info.cases,
                                      function (casesItem, casesIndex) {
                                        return [
                                          _c("p", { key: casesIndex }, [
                                            _vm._v(_vm._s(casesItem.name)),
                                          ]),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _c("h1", { staticClass: "case-title" }, [
                                  _vm._v(_vm._s(_vm.mpc_info.currentCaseName)),
                                ]),
                              ]
                            )
                          : _c("h1", { staticClass: "case-title" }, [
                              _vm._v(_vm._s(_vm.mpc_info.currentCaseName)),
                            ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1105979335
              ),
            }),
            _c(
              "div",
              { staticClass: "case-open" },
              [
                _vm.mpc_info.cases && _vm.mpc_info.cases.length == 1
                  ? _c(
                      "p-case-opening",
                      {
                        ref: "multiplePeopleCase_opening_box",
                        staticClass: "case-openOneItem",
                        attrs: {
                          items: _vm.mpc_info.cases[0].case_awards,
                          isTransition:
                            !_vm.is_jump_multiplePeopleCase_open_animation,
                        },
                        on: { on_finished: _vm.on_multiplePeopleCase_opened },
                      },
                      [
                        !_vm.isRunning
                          ? _c("div", { staticClass: "case-con" }, [
                              _c("div", { staticClass: "case-img-con" }, [
                                _c("div", { staticClass: "case-img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm._f("imgfilter")(
                                        _vm.mpc_info.cases[0].picture
                                      ),
                                    },
                                  }),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm.mpc_info.cases && _vm.mpc_info.cases.length > 1
                  ? _c("p-case-opening-more", {
                      ref: "mpc_case_opening_box_more",
                      staticClass: "case-openMoreItem",
                      attrs: {
                        mpCasesList: _vm.mpc_info.cases,
                        lotteryCount: _vm.mpc_info.cases.length,
                        isMobile: _vm.$screen.mobile,
                        currentWidth: _vm.currentWidth,
                        isTransition:
                          !_vm.is_jump_multiplePeopleCase_open_animation,
                      },
                      on: { on_finished: _vm.on_multiplePeopleCase_opened },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "ctrl-con flex flex-center-1" }, [
              _c(
                "div",
                {
                  staticClass:
                    "ctl-con-contributionCount flex flex-ver flex-jcfe",
                },
                [
                  _vm.mpc_info.status == 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "ctl-con-contributionCount-item flex flex-col flex-center-1",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "contributionCount-item flex flex-center-1",
                            },
                            [
                              _c("p", [_vm._v("份数：")]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "contributionCount_btn flex flex-center-1",
                                  class: {
                                    contributionCountReducedisable:
                                      !_vm.initPageCheckContriCount ||
                                      _vm.contributionCount <= 1,
                                  },
                                  on: {
                                    click:
                                      _vm.handleContributionCountReduceSelect,
                                  },
                                },
                                [_vm._v(" - ")]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.contributionCount,
                                    expression: "contributionCount",
                                  },
                                ],
                                staticClass: "contributionCount__input",
                                attrs: {
                                  readonly: !_vm.initPageCheckContriCount,
                                },
                                domProps: { value: _vm.contributionCount },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.contributionCount =
                                        $event.target.value
                                    },
                                    _vm.onContributionCountInput,
                                  ],
                                  blur: _vm.onContributionCountBlur,
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "contributionCount_btn flex flex-center-1",
                                  class: {
                                    contributionCountReducedisable:
                                      !_vm.initPageCheckContriCount ||
                                      !_vm.onCheckContributionCountInput
                                        .checkstatus,
                                  },
                                  on: {
                                    click: _vm.handleContributionCountAddSelect,
                                  },
                                },
                                [_vm._v(" + ")]
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "lowCount-item" }, [
                            _c("p", [
                              _vm._v(" 最低份额(1份) "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("conversion")(
                                      Number(
                                        _vm.mpc_info.price *
                                          _vm.mpCaseList.mpcCaseSettings
                                            .mpCaseMinimumPercent
                                      )
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                { staticClass: "ctl-con-middle flex flex-col flex-center-1" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "current-contribution-item flex flex-end flex-jcsb",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col flex-center-1" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text",
                              staticStyle: { "margin-bottom": "4px" },
                            },
                            [_vm._v("合开状态")]
                          ),
                          _c("p", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("conversion")(_vm.mpc_info.currAmount)
                                ) +
                                  "(" +
                                  _vm._s(_vm.mpc_info.curAmountRatio) +
                                  "%)"
                              ),
                            ]),
                            _vm._v(" / "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("conversion")(_vm.mpc_info.price))
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm.mpc_info.joinPrice && _vm.mpc_info.joinPrice > 0
                        ? _c(
                            "div",
                            { staticClass: "flex flex-col flex-center-1" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "textRight",
                                  staticStyle: { "margin-bottom": "4px" },
                                },
                                [_vm._v("我的份额")]
                              ),
                              _c("p", { staticClass: "textRight" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("conversion")(
                                        _vm.mpc_info.joinPrice
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "(" + _vm._s(_vm.mpc_info.joinRatio) + "%)"
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "ctl-con-btns flex flex-center-1" },
                    [
                      _vm.mpc_info.status == 0 &&
                      _vm.mpc_info.joinRatio <
                        Number(
                          _vm.mpCaseList.mpcCaseSettings.mpCaseMaximumPercent *
                            100
                        )
                        ? _c(
                            "button",
                            {
                              staticClass: "btnItem flex flex-center-1",
                              class: {
                                "btnItem-disabled": _vm.isMainBtnLoading,
                              },
                              on: { click: _vm.onMPContributionHandler },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "flex flex-ver flex-jcfe",
                                  staticStyle: {
                                    flex: "1 1 0%",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm.isMainBtnLoading
                                    ? _c("c-loading-scope", {
                                        staticStyle: { width: "50px" },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "flex flex-ver" }, [
                                _vm.mpc_info.isPrivate
                                  ? _c("i", {
                                      staticClass: "elIconItem el-icon-lock",
                                    })
                                  : _vm._e(),
                                _vm._v("  "),
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "totalSelectedPrice-item":
                                        _vm.curUserRealId ==
                                        _vm.mpc_info.ownerId,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.lastShowPrice) +
                                        "(" +
                                        _vm._s(_vm.lastShowPriceRatio) +
                                        "%)"
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.curUserRealId == _vm.mpc_info.ownerId
                                  ? _c(
                                      "span",
                                      { staticClass: "lastCreatePrice-item" },
                                      [_vm._v(_vm._s(_vm.lastCreatePrice))]
                                    )
                                  : _vm._e(),
                              ]),
                              _c("div", { staticStyle: { flex: "1 1 0%" } }),
                            ]
                          )
                        : _vm._e(),
                      _vm.mpc_info.status == 0 &&
                      _vm.mpc_info.joinRatio >=
                        Number(
                          _vm.mpCaseList.mpcCaseSettings.mpCaseMaximumPercent *
                            100
                        )
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btnItem btnItem-disabled flex flex-center-1",
                            },
                            [_vm._v(" 已达到当前可合开最大份额 ")]
                          )
                        : _vm._e(),
                      _vm.mpc_info.status == 1
                        ? _c(
                            "button",
                            {
                              staticClass: "btnItem flex flex-center-1",
                              class: {
                                "btnItem-disabled": _vm.isMainBtnLoading,
                              },
                              on: { click: _vm.onMPCOpenHandler },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "flex flex-ver flex-jcfe",
                                  staticStyle: {
                                    flex: "1 1 0%",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm.isMainBtnLoading
                                    ? _c("c-loading-scope", {
                                        staticStyle: { width: "50px" },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.isRunning ? "打开中" : "查看开箱"
                                  ) +
                                  " "
                              ),
                              _c("div", { staticStyle: { flex: "1 1 0%" } }),
                            ]
                          )
                        : _vm._e(),
                      _vm.mpc_info.status > 1
                        ? _c(
                            "button",
                            {
                              staticClass: "btnItem flex flex-center-1",
                              class: { "btnItem-disabled": true },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    ["已创建", "已打开", "未达标", "已取消"][
                                      _vm.mpc_info.status
                                    ]
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "jump-animate-con flex flex-ver" },
                [
                  _vm.mpc_info.status == 1
                    ? _c(
                        "div",
                        { staticClass: "jump-animate" },
                        [
                          _c("i-switch", {
                            attrs: {
                              "false-color": "#14131d",
                              "true-color": "#827dff",
                            },
                            on: {
                              "on-change":
                                _vm.toggleMultiplePeopleCaseAnimation,
                            },
                            model: {
                              value:
                                _vm.is_jump_multiplePeopleCase_open_animation,
                              callback: function ($$v) {
                                _vm.is_jump_multiplePeopleCase_open_animation =
                                  $$v
                              },
                              expression:
                                "is_jump_multiplePeopleCase_open_animation",
                            },
                          }),
                          _c("span", { staticClass: "text" }, [_vm._v("动画")]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.mpc_info.status == 0
                    ? _c("c-countDown", {
                        staticClass: "countDown__item",
                        on: {
                          countdownDinished: function ($event) {
                            return _vm.init_mpcDetail()
                          },
                        },
                        model: {
                          value: _vm.mpc_info.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.mpc_info, "endTime", $$v)
                          },
                          expression: "mpc_info.endTime",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "multiplePeople-items" }, [
              _c(
                "div",
                { staticClass: "multiplePeople-tab-item flex flex-ver" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tabItem flex flex-center-1",
                      class: { "tabItem-active": _vm.currentMPCTab == 1 },
                      on: {
                        click: function ($event) {
                          _vm.currentMPCTab = 1
                        },
                      },
                    },
                    [_vm._v(" 合开名单")]
                  ),
                  _vm.mpc_info.status == 1
                    ? _c(
                        "div",
                        {
                          staticClass: "tabItem flex flex-center-1",
                          class: { "tabItem-active": _vm.currentMPCTab == 2 },
                          on: {
                            click: function ($event) {
                              _vm.currentMPCTab = 2
                            },
                          },
                        },
                        [_vm._v(" 获奖名单")]
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                {
                  ref: "multiplePeopleList",
                  staticClass: "multiplePeople-list-item",
                },
                [
                  _vm._l(_vm.mpc_info.players, function (item, index) {
                    return _vm.currentMPCTab == 1
                      ? _c(
                          "div",
                          {
                            key: index,
                            staticClass: "listItem flex flex-col flex-center-1",
                          },
                          [
                            _c("el-avatar", {
                              attrs: { size: "large", src: item.avatar },
                            }),
                            _c("p", { staticClass: "name" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                            _c("p", { staticClass: "contribution" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("conversion")(item.amount)) +
                                  " (" +
                                  _vm._s(item.ratio) +
                                  "%) "
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  _vm._l(_vm.awardPlayerList, function (item, index) {
                    return _vm.currentMPCTab == 2
                      ? _c(
                          "div",
                          {
                            key: index,
                            staticClass: "listItem flex flex-col flex-center-1",
                          },
                          [
                            _c("el-avatar", {
                              attrs: { size: "large", src: item.avatar },
                            }),
                            _c("p", { staticClass: "name" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                ],
                2
              ),
            ]),
            _c("div", { staticClass: "cases-detail-items" }, [
              _c(
                "div",
                { staticClass: "cases-detail-top-items flex flex-center-1" },
                _vm._l(
                  _vm.mpc_info.cases,
                  function (cases_detail_item, cases_detail_index) {
                    return _c(
                      "div",
                      {
                        key: cases_detail_index,
                        staticClass:
                          "cases-detail-top-item flex flex-col flex-center-1",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "cases-detail-top-title-item flex flex-center-1",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.openCaseDetailMoreModal(
                                  cases_detail_item
                                )
                              },
                            },
                          },
                          [
                            _c("p", [_vm._v("掉落概率")]),
                            _c("img", {
                              attrs: {
                                src: require("../../assets/images/help_fill.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                        _c("el-image", {
                          staticClass: "case-img-item",
                          class: {
                            "case-img-active":
                              cases_detail_index == _vm.current_case_drop_index,
                            "case-img-no-active":
                              cases_detail_index != _vm.current_case_drop_index,
                          },
                          attrs: {
                            src: _vm._f("imgfilter")(cases_detail_item.picture),
                            fit: "cover",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.swtichCasesDropHandle(
                                cases_detail_index
                              )
                            },
                          },
                        }),
                        _c(
                          "p",
                          {
                            staticClass: "caseNameItem",
                            class: {
                              "caseNameItem-active":
                                cases_detail_index ==
                                _vm.current_case_drop_index,
                            },
                          },
                          [_vm._v(" " + _vm._s(cases_detail_item.name) + " ")]
                        ),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
              _c("div", { staticClass: "cases-recentRate-item" }, [
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "cases-recentRate-drop" },
                  _vm._l(
                    _vm.mpc_info.cases[_vm.current_case_drop_index].drop_awards,
                    function (item, award_index) {
                      return _c(
                        "div",
                        { key: award_index, staticClass: "item" },
                        [
                          _c("c-award", {
                            staticClass: "award",
                            attrs: {
                              rarity: item.rarity,
                              picture: item.itempic,
                              name: item.itemname,
                              price: item.price,
                              width: "100%",
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]),
            ]),
            _c("c-open-multiple-people-case-item", {
              attrs: {
                players: _vm.mpc_info.players,
                autoMPCCaseOpen: _vm.autoMPCCaseOpen,
                case_opened_awards: _vm.case_opened_awards,
              },
              on: { onCloseRewardHandle: _vm.onCloseRewardHandle },
              model: {
                value: _vm.is_open_multiplePeopleCase,
                callback: function ($$v) {
                  _vm.is_open_multiplePeopleCase = $$v
                },
                expression: "is_open_multiplePeopleCase",
              },
            }),
            _c(
              "Drawer",
              {
                attrs: {
                  "class-name": "app-drawer",
                  transfer: false,
                  placement: "bottom",
                  height: "350",
                },
                model: {
                  value: _vm.isCaseDetailMoreModal,
                  callback: function ($$v) {
                    _vm.isCaseDetailMoreModal = $$v
                  },
                  expression: "isCaseDetailMoreModal",
                },
              },
              [
                _c("c-battleCaseDetail", {
                  attrs: { caseInfo: _vm.caseDetailMoreDetail },
                }),
              ],
              1
            ),
            _c(
              "Modal",
              {
                attrs: {
                  "class-name": "app-modal",
                  "footer-hide": "",
                  width: "'400rem'",
                  closable: false,
                },
                model: {
                  value: _vm.isShowPassword,
                  callback: function ($$v) {
                    _vm.isShowPassword = $$v
                  },
                  expression: "isShowPassword",
                },
              },
              [
                _c(
                  "c-interactive-panel",
                  {
                    attrs: { title: "输入密码", has_close_button: "" },
                    on: {
                      close_button_click: function () {
                        return (_vm.isShowPassword = false)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "app-form" }, [
                      _c(
                        "p",
                        {
                          staticClass: "join_room_modal_desc",
                          staticStyle: { "padding-top": "8px" },
                        },
                        [_vm._v(" 当前多人开箱需要输入密码 ")]
                      ),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password",
                        },
                      ],
                      staticClass: "form-input",
                      attrs: {
                        type: "password",
                        placeholder: "请输入多人开箱密码",
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "submit-button",
                        staticStyle: { width: "100%" },
                        on: { click: _vm.onMPCJoinHandle },
                      },
                      [_vm._v(" 确认加入 ")]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              "div",
              { staticClass: "loading-con flex flex-center-1" },
              [_c("c-loading-scope")],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cases-recentRate-title" }, [
      _c("p", [_vm._v("最近掉落")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }